<template>
    <transition name="cz3__fade">
        <div
            v-if="showModal"
            class="z-50 fixed top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-black bg-opacity-30"
        >
            <div class="shadow-md rounded w-full sm:w-1/2 max-w-2xl p-4 md:p-9 flex flex-col bg-white text-ink">
                <div class="flex justify-end">
                    <button
                        @click="emitClose"
                        type="button"
                        aria-label="close modal"
                        class="h-auto"
                    >
                        <img
                            src="../assets/images/icons/close.svg"
                            width="20"
                            height="20"
                            alt="X"
                        >
                    </button>
                </div>

                <div class="flex-1 overflow-auto text-center">
                    <div class="min-h-[70px]">
                        <img
                            :src="`https://acushnet.scene7.com/is/image/MyJoysRender/${specialMessage.icon}?fmt=png-alpha&hei=150`"
                            height="auto"
                            width="80"
                            class="mx-auto"
                        >
                    </div>

                    <h1 class="mb-2 uppercase text-2xl font-bold">
                        {{ specialMessage.title }}
                    </h1>

                    <div
                        v-html="specialMessage.body"
                        class="cz3-promo-details-modal"
                    ></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<style>
    #cz3 .cz3-promo-details-modal p {
        @apply mb-4;
    }
</style>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            specialMessage() {
                return this.customizerStore.specialMessage;
            },
        },

        methods: {
            emitClose() {
                this.$emit('modalClose');
            },
        },
    };
</script>
